<script>
import {VueMaskDirective as mask} from 'v-mask'
import service from '../../../../domain/arrematantes/services'

export default {
  components: {},
  nome: 'estatisticas-cadastro-arrematante',
  directives: {mask},
  data () {
    return {
      dados: null
    }
  },
  computed: {
    dadosFiltrados () {
      return this.dados
    }
  },
  mounted () {
  },
  activated () {
  },
  created () {
    this.$loaderOverlay.open().message('Aguarde enquanto carregamos as informações iniciais')
    this.$interval = setInterval(() => {
      this.load()
    }, 300000)
    this.load()
  },
  beforeDestroy () {
    window.clearInterval(this.$interval)
  },
  deactivated () {
    window.clearInterval(this.$interval)
    this.$destroy() // no keep-alive
  },
  watch: {},
  methods: {
    load () {
      service.estatisticasCadastro()
        .then((response) => {
          this.$loaderOverlay.hide()
          this.dados = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    }
  }
}
</script>

<template>
  <div>
    <div v-if="dados" class="wrapper-md dados-container">
      <div class="dados">
        <div class="title">Total de Cadastros</div>
        <div class="info">{{dados.total|number}}</div>
      </div>

      <div class="dados">
        <div class="title">Incompletos</div>
        <div class="info">{{dados.incompletos|number}}</div>
      </div>

      <div class="dados">
        <a href="/#/website/arrematantes/aprovacao" target="_blank">
          <div class="title">Pendentes para Aprovação</div>
          <div class="info">{{dados.pendentesAprovacao|number}}</div>
        </a>
      </div>

      <div class="dados">
        <div class="title text-primary">Não Aprovados</div>
        <div class="info">{{dados.naoAprovados|number}}</div>
      </div>

      <div class="dados">
        <div class="title text-danger">Bloqueados</div>
        <div class="info">{{dados.bloqueados|number}}</div>
      </div>

      <div class="dados">
        <div class="title text-success">Aprovados</div>
        <div class="info">{{dados.aprovados|number}}</div>
      </div>

      <div class="dados">
        <div class="title text-success">Aprovados Ontem</div>
        <div class="info">{{dados.aprovadosOntem|number}}</div>
      </div>

      <div class="dados">
        <div class="title text-success">Analisados Hoje</div>
        <div class="info">{{dados.analisesHoje|number}}</div>
      </div>

      <div class="dados">
        <div class="title text-success">Aprovados Hoje</div>
        <div class="info">{{dados.aprovadosHoje|number}}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .dados-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .dados {
      width: 30%;
      height: 200px;
      background: #FFFFFF;
      margin-bottom: 20px;
      display: flex;
      padding: 30px;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      flex-direction: column;
      text-align: center;
      -webkit-box-shadow: 0 3px 6px -1px rgba(0, 0, 0, .16);
      box-shadow: 0 3px 6px -1px rgba(0, 0, 0, .16);

      .info {
        font-size: 42px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// EstatisticaCadastro.vue?695ea2b7